import {
  FILE_ORIGIN_GENERATED,
  MediaFile,
} from '../../data/models/LibraryFile/MediaFile';

/** Studio renders are revised through Studio, never through the legacy chunk editor. */
export const canUseLegacyVideoEditor = (file: MediaFile) =>
  file.origin === FILE_ORIGIN_GENERATED &&
  file.editable !== false &&
  !file.studioJobId &&
  !file.studioRevisionId;

export const studioEditorPath = (organizationId: string, jobId: string) =>
  `/manage/${encodeURIComponent(
    organizationId,
  )}/microreels/studio/microreels/${encodeURIComponent(jobId)}/storyboard`;
